export default class GeneratorMessageError extends Error {}
